export const notifications = {
  // LOGIN_SUCCESS: 'Login successful',
  // PASS_MATCH: ' Password not match',
  // MAIL_VERIFY: '  Verify successful',
  // CODE_RESEND: ' We resend verify code',
  // REGISTER_DIFFERENT_ACCOUNT: ' You can register diffrent email account',
  // DELETE_PRESCRIPTION: 'Deleted',
  // CREATE_PRESCRIPTION: 'Prescription created',
  // EDIT_PRESCRIPTION: 'Prescription edited',
  // PRES_FIELD_ERROR: 'You must fill at least one refraction field',
  // USER_UPDATED: 'User updated',
  // CUPON_ACCESS: 'Cupon access',
  // CUPON_REMOVE: 'Cupon removed',
  // ADD_BASKET: 'Product has been successfully added to your cart.',
  // UPDATE_ITEM: 'Product has been successfully updated ',
  // SERVICE_ERROR: 'Service error',
  LOGIN_SUCCESS: 'Login successful',
  PASS_MATCH: ' Password does not match',
  MAIL_VERIFY: 'Mail verification successful',
  CODE_RESEND: ' We re-sent your verification code',
  REGISTER_DIFFERENT_ACCOUNT:
    'You can register again with a different email account',
  DELETE_PRESCRIPTION_MESSAGE: 'Prescription deleted',
  CREATE_PRESCRIPTION: 'Prescription created',
  EDIT_PRESCRIPTION: 'Prescription edited',
  PRES_FIELD_ERROR: 'Please fill in at least one prescription field',
  PRES_PD_TYPE_ERROR:
    'The sum of your two monocular PD measurements should be equal to your binocular pupillary distance.',
  PRES_CYL_AXIS_MISMATCH_ERROR:
    'You chose CYL value, please enter a value for Axis value',
  USER_UPDATED: 'User updated',
  CUPON_ACCESS: 'Coupon applied to cart',
  CUPON_REMOVE: 'Coupon removed from cart',
  ADD_BASKET: 'Product added to your cart.',
  UPDATE_ITEM: 'Product updated in your cart',
  SERVICE_ERROR: 'We received an error from our service. Please try again',
  SELECTED_ADDRESS_PHONE_IS_NOT_VALID:
    'The selected address does not have a valid phone number, please enter a valid phone number by editing the selected address.',
  UPDATE_SUCCESS: 'Updates saved &#9996;',
  PRESCRIPTION_USED_DETELED: 'The prescription you are trying to delete is used by a product in your basket. Please empty your basket first before deleting this prescription.',
  MULTIFOCAL_ADD_VALUE: 'Multifocal glasses need "add values". Please enter an add value to continue',
  BIFOCAL_ADD_VALUE: 'Bifocal glasses need "add values". Please enter an add value to continue',
  AXIS_ERROR: 'Please enter a value between 1-180 for Axis',
  CYL_ERROR: 'You chose Axis value, please enter a value for CYL value',
  READING_ADD_VALUE: 'Please make sure to enter the Addition (ADD) value if it is listed in your prescription, otherwise proceed with the order.',
  SPH_DIFFRENT: 'That\'s unsual! For most people, both eyes have either negative (-) or positive (+) SPH values. Are you sure your prescription shows both?',
};
